import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export default function Login() {
  const location = useLocation()
  const me = useQuery({ queryKey: ['me'], queryFn: api.me })

  const fromQuery = new URLSearchParams(location.search).get('from') || '/'
  useEffect(() => {
    document.title = 'Login — Mini CRM'
  }, [])

  if (me.data?.authenticated) {
    return <Navigate to={fromQuery} replace />
  }

  const loginHref = `/auth/login?redirect=${encodeURIComponent(fromQuery)}`

  return (
    <div className="flex h-screen items-center justify-center bg-slate-50">
      <div className="w-full max-w-sm rounded-xl border border-slate-200 bg-white p-8 shadow-sm">
        <h1 className="mb-2 text-xl font-semibold text-slate-900">Mini CRM</h1>
        <p className="mb-1 text-xs font-medium uppercase tracking-wide text-slate-400">Spiders Web</p>
        <p className="mb-6 text-sm text-slate-500">
          Zaloguj się kontem Google, żeby zarządzać konfiguracją serwisów.
        </p>
        <a
          href={loginHref}
          className="flex w-full items-center justify-center gap-2 rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-slate-800"
        >
          <GoogleIcon />
          Zaloguj przez Google
        </a>
        {me.data && me.data.authenticated === false && me.data.email && (
          <p className="mt-4 text-xs text-rose-600">
            Konto {me.data.email} nie jest na liście dozwolonych.
          </p>
        )}
      </div>
    </div>
  )
}

function GoogleIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#fff" d="M21.35 11.1H12v3.18h5.36c-.23 1.49-1.7 4.36-5.36 4.36-3.22 0-5.85-2.66-5.85-5.94S8.78 6.76 12 6.76c1.83 0 3.06.78 3.76 1.45l2.56-2.46C16.78 4.27 14.6 3.3 12 3.3 6.95 3.3 2.85 7.4 2.85 12.7S6.95 22.1 12 22.1c6.92 0 9.5-4.86 9.5-7.4 0-.5-.05-.88-.15-1.6z" />
    </svg>
  )
}
